import ScreenAdList from 'screens/Ad/List';
import ScreenAdDetails from 'screens/Ad/Details';
import { AD } from 'routes/paths';

const adsRoutes = [
  {
    path: AD.DETAILS,
    name: 'AdDetails',
    component: ScreenAdDetails,
    allowPermissions: ['view_ad'],
  },
  {
    path: AD.LIST,
    name: 'AdList',
    component: ScreenAdList,
    loginRequired: true,
    allowPermissions: ['list_ad'],
  },
];

export default adsRoutes;
